import React, { useState, createContext, useEffect } from 'react';
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { decodeToken } from "react-jwt";


export const UsuarioAutenticadoContext = createContext();

const isUserLogged = stored => !!stored && stored !== "caducado";

function estoyLogueado(loc) {
  const stored = localStorage.getItem("token-taxo");
  if (isUserLogged(stored) || loc === "/login") {
    return true
  }
  return false
}

export function UsuarioAutenticadoProvider({ children }) {
  const history = useNavigate();
  const location = useLocation();
  const initialUsuarioAutenticado = {
    user: null,
    password: null,
    id_usuario: null,
    id_entidad: null,
    desc_entidad: "",
    alias: "",
    permiso_ver_dashboard: null,
  };

  const [usuarioAutenticado, setUsuarioAutenticado] = useState(() => {
    const token = localStorage.getItem('token-taxo');
    if (isUserLogged(token)) {
      try {
        const decoded = decodeToken(token);
        localStorage.setItem('token-taxo', token);
        return {
          user: decoded.name ?? null,
          password: decoded.hash ?? null,
          id_usuario: decoded.id_usuario ?? null,
          id_entidad: decoded.id_entidad ?? null,
          desc_entidad: decoded.desc_entidad ?? "",
          alias: decoded.alias ?? "",
          permiso_ver_dashboard: decoded.permiso_dashboard ?? null
        };
      } catch (err) {
        console.log('Error de autenticación:', err);
        localStorage.removeItem('token-taxo');
        return { ...initialUsuarioAutenticado };
      }
    }
    return { ...initialUsuarioAutenticado };
  });

  useEffect(() => {
    console.log ('usuarioAutenticado', usuarioAutenticado)
  }, [usuarioAutenticado])

  const provider = {
    usuarioAutenticado,
    usuarioAutenticadoChange: (updates) => {
      setUsuarioAutenticado(prev => ({
        ...prev,
        ...updates
      }));
    },
    logout: () => {
      localStorage.removeItem('token-taxo');
      setUsuarioAutenticado(null);
    }
  };

  return (
    <UsuarioAutenticadoContext.Provider value={provider}>
      {estoyLogueado(location.pathname) ? children : <Navigate to='/login' />}
    </UsuarioAutenticadoContext.Provider>
  );
};
